// Hook React pour charger les catégories VISIBLES depuis l'API.
// État initial = vide pour ne JAMAIS afficher une catégorie désactivée par l'admin,
// même brièvement avant la réponse de l'API.
import { useEffect, useState } from "react";
import { api } from "./api";

let CACHE = null;
let CACHE_TS = 0;
const TTL_MS = 60 * 1000;

export function useCategories() {
  const [cats, setCats] = useState(CACHE || []);
  const [loaded, setLoaded] = useState(!!CACHE);

  useEffect(() => {
    let cancelled = false;
    const now = Date.now();
    if (CACHE && now - CACHE_TS < TTL_MS) {
      setCats(CACHE);
      setLoaded(true);
      return;
    }
    (async () => {
      try {
        const r = await api.get("/categories");
        const arr = r.data?.categories || [];
        if (cancelled) return;
        CACHE = arr;
        CACHE_TS = Date.now();
        setCats(arr);
        setLoaded(true);
      } catch {
        setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { cats, loaded };
}

export function invalidateCategoriesCache() {
  CACHE = null;
  CACHE_TS = 0;
}
